import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: 18,
    margin: 1,
  },
}));

export default function ReportDetailsItem(props) {
  const classes = useStyles();
  return (
    <p className={classes.text}>
      <b>{`${props.title}: `}</b>
      {props.value}
    </p>
  );
}
